'use strict';

// Public web typography only. Product UI and native apps retain system fonts.
// The Pug renderer and React landing pages consume the same family and assets.
module.exports = Object.freeze({
  fontFamily: 'Inter, "Inter Fallback", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  regularUrl: '/fonts/public-glu/InterVariable-4.1.woff2',
  italicUrl: '/fonts/public-glu/InterVariable-Italic-4.1.woff2',
});
